var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.75H14.0625V3.87449L15.75 3.87421V15.1251H14.0625V16.2501H15.75C16.3704 16.2501 16.875 15.7455 16.875 15.1251V3.875C16.875 3.25456 16.3704 2.75 15.75 2.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.1875C9.62132 11.1875 10.125 10.6838 10.125 10.0625C10.125 9.44118 9.62132 8.9375 9 8.9375C8.37868 8.9375 7.875 9.44118 7.875 10.0625C7.875 10.6838 8.37868 11.1875 9 11.1875Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 2.75V16.25C12.375 16.8704 11.8704 17.375 11.25 17.375H2.25C1.62956 17.375 1.125 16.8704 1.125 16.25V2.75C1.125 2.12956 1.62956 1.625 2.25 1.625H11.25C11.8704 1.625 12.375 2.12956 12.375 2.75ZM2.25 16.25H11.25V2.74916L2.25 2.75V16.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckIn);
export default __webpack_public_path__ + "static/media/ic-check-in.96a0f2a596b569bc2032d4c4a6e6c093.svg";
export { ForwardRef as ReactComponent };